module.exports = __webpack_public_path__ + "european-union.svg?7aea52bbbc38e6d8f93bf6f50c467452";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/european-union.svg
// module id = 162
// module chunks = 10